import { http } from "@/api/common";

export default {
  async get(idToken) {
    return http.get(`/customers`, undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async changeSettings(idToken, payload) {
    return http.post(`/customers/settings`, payload, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },
};
